const preferredCountriesMixin = {
  computed: {
    preferredCountries () {
      return process.env.VUE_APP_COUNTRY === 'Brasil' ? ['BR', 'CO', 'US'] : ['CO', 'US']
    },
    defaultCountry () {
      return process.env.VUE_APP_COUNTRY === 'Brasil' ? 'BR' : 'CO'
    }
  }
}
export default preferredCountriesMixin
